<template>
  <router-link to="/team" class="services__next-page" tag="div">
    <h2 class="services__next-page--title">{{ $t("servicesTranslate.servicesNextPageLinkToNextPage") }}</h2>
  </router-link>
</template>

<script>
export default {
  name: 'services-next-page',
  data() {
    return {
      locale: 'fr'
    }
  },
  watch: {
    locale (val) {
      this.$i18n.locale = val
    }
  }
}
</script>

<style lang="css">
</style>
